import setClientTimeCookies from "meta/extensions/client-time-cookies/client-time-cookies";
import { useEffect } from "react";
export const useClientTimeCookies = () => {
    useEffect(() => {
        setClientTimeCookies();
    }, []);
};
